import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import { mapStyles } from "../../utils/data/mapStyle";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import { GoogleMap } from "../Global/Maps/GoogleMap";
import Spinner from '../Global/Atomics/Spinner';
import { io } from "socket.io-client";
import { useEffect, useState } from "react";
import { websocketPort } from "../../server/websocketPort";
import Theme from '../../styles/Theme/Theme';
import { notification } from "antd";

const socket = io(websocketPort);
// function initSocket(socket) {
//     socket.on("connect", () => {
//         console.log("React websocket");

//     });
// }

// initSocket(socket);


export const MapsWidget = ({widgetHeight}) => {
    const [incidents, setIncidents] = useState();
    const [realtimeBus, setRealtimeBus] = useState();

    const { data: mapConfigurationData, isLoading: mapConfigurationLoading, refetch: refetchMapConfiguration } = useFetch(query.path.mapConfiguration, 'getMapConfiguration');
    const { data: incidentsData, isLoading: incidentsLoading, refetch: refetchIncidents } = useFetch(query.path.incidents, 'getIncidents', { tenant: 'TOP/CASCAIS' });

    const bus = useFetch(query.path.realtimeBus, 'getRealtimeBus', null, 60000)

    useEffect(() => {
        setIncidents(incidentsData?.data?.result);
    }, [incidentsData?.data])//queryResults[1]?.data?.data

    useEffect(() => {
        setRealtimeBus(bus?.data?.data)
    }, [bus?.data?.data])

    useEffect(() => {
        socket.on("incidents", (text) => {
            let incs = JSON.parse(text);
            console.log('Novo incidente', incs);
            if(incs?.data){
                // setIncidents((prevIncidents) => {
                //     return [...prevIncidents, incs.data];
                // })
                refetchIncidents();
            //     const family = incs.data?.service_family.split('.')?.[1] ?? '';
            //     notification.error({
            //         message: 'New Incident',
            //         description:
            //           'Familia: ' + family,
            //       //   onClick: () => {
            //       //     console.log('Notification Clicked!');
            //       //   },
            //       duration: 15,
            //       placement: 'topLeft'
            //   });
            }
        });
    }, [])

    if (!mapConfigurationLoading && mapConfigurationData.data?.styles && mapConfigurationData.data?.hide.length) {
        mapConfigurationData.data?.hide.map((el) => {
            mapStyles[mapConfigurationData.data?.styles].push(
                {
                    featureType: "poi." + el,
                    stylers: [{ visibility: "off" }],
                },
            )
        })

    }

    return (
        <WidgetCard margin={Theme.spacing.videowall.xxs} height={widgetHeight}>
            {!mapConfigurationLoading && !incidentsLoading && !bus.isLoading  ?
                <GoogleMap configurations={mapConfigurationData.data} incidents={incidents} realtimebus={realtimeBus} />
                : <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" /></div>}
        </WidgetCard>
    )
}